if (!customElements.get('if-quantity-offers')) {
  customElements.define('if-quantity-offers',class extends HTMLElement {
    connectedCallback(){
      this.abort=new AbortController();this.product=this.closest('product-info');
      this.quantity=this.product?.querySelector('.quantity__input');
      this.form=this.product?.querySelector('#'+CSS.escape(this.dataset.form));
      if(!this.quantity||!this.form)return;
      this.variants=JSON.parse(this.querySelector('[data-offer-variants]').textContent);
      this.offers=[...this.querySelectorAll('[data-offer]')];
      if(!this.offers.length)return;
      this.quantity.closest('.product-form__quantity')?.classList.add('if-offers-ready');
      this.currentId=this.form.querySelector('[name=id]')?.value;
      const on=(el,event,fn,opts={})=>el?.addEventListener(event,fn,{...opts,signal:this.abort.signal});
      on(this,'change',e=>{
        if(e.target.matches('[data-offer]')){
          this.quantity.value=e.target.value;
          this.lastQuantity=Number(this.quantity.value);
          this.quantity.dispatchEvent(new Event('change',{bubbles:true}));
          this.renderUnits();this.renderPrices();
        } else if(e.target.matches('[data-unit]'))this.renderPrices();
      });
      on(this.quantity,'change',()=>{this.lastQuantity=Number(this.quantity.value);this.syncOffers();this.renderUnits();this.renderPrices();});
      on(this.form,'submit',e=>this.submit(e),{capture:true});
      on(this.form.querySelector('[name=id]'),'change',e=>{
        this.currentId=e.target.value;
        this.syncOffers();
        if(!this.currentId){this.renderUnits();this.renderPrices();}
      });
      this.unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,({data})=>{
        if(data.sectionId!==this.dataset.section)return;
        this.currentId=String(data.variant?.id||'');
        const sourceVariants=data.html?.querySelector('if-quantity-offers [data-offer-variants]');
        if(sourceVariants){try{this.variants=JSON.parse(sourceVariants.textContent);}catch{}}
        if(data.variant){
          const index=this.variants.findIndex(v=>String(v.id)===this.currentId);
          if(index>=0)this.variants[index]={...this.variants[index],price:data.variant.price,compare_at_price:data.variant.compare_at_price===undefined?this.variants[index].compare_at_price:data.variant.compare_at_price,available:data.variant.available};
        }
        const sourceQuantity=data.html?.getElementById(`Quantity-${this.dataset.section}`);
        const wanted=this.lastQuantity||Number(this.quantity.value);
        const min=Number(sourceQuantity?.dataset.min||sourceQuantity?.min||this.quantity.min||1);
        const max=sourceQuantity?.dataset.max?Number(sourceQuantity.dataset.max):Infinity;
        const step=Number(sourceQuantity?.step||this.quantity.step||1);
        if(wanted>=min&&wanted<=max&&(wanted-min)%step===0){
          this.quantity.value=String(wanted);
          this.quantity.dispatchEvent(new Event('change',{bubbles:true}));
        }else this.lastQuantity=Number(this.quantity.value);
        this.syncOffers();this.renderUnits(true);this.renderPrices();
      });
      this.qtyUnsubscribe=subscribe(PUB_SUB_EVENTS.quantityUpdate,()=>{queueMicrotask(()=>{if(this.isConnected){
        this.syncOffers();
        const last=this.offers.find(input=>!input.disabled&&Number(input.value)===this.lastQuantity);
        if(last){this.quantity.value=last.value;this.syncOffers();}
        this.renderUnits();this.renderPrices();
      }});});
      this.syncOffers();
      if(this.dataset.preselect==='first'){
        const first=this.offers.find(input=>!input.disabled);
        if(first){this.quantity.value=first.value;this.quantity.dispatchEvent(new Event('change',{bubbles:true}));}
      }
      this.renderUnits();this.renderPrices();
      this.lastQuantity=Number(this.quantity.value);

    }
    current(){return this.variants.find(v=>String(v.id)===String(this.currentId));}
    mixedAllowed(q){return this.dataset.unitVariants==='true'&&(q>1||this.dataset.singlePicker==='true')&&q<=20&&q>0&&!!this.current();}
    syncOffers(){
      const current=this.current(),cartQuantity=Number(this.quantity.dataset.cartQuantity||0);
      const ruleMin=Number(this.quantity.dataset.min||current?.min||1);
      const min=cartQuantity>=ruleMin?Number(current?.step||1):ruleMin;
      const max=this.quantity.dataset.max?Math.max(0,Number(this.quantity.dataset.max)-cartQuantity):Infinity;
      const step=Number(current?.step||1);
      const mixed=this.mixedAllowed(Number(this.quantity.value));
      this.quantity.min=String(mixed?1:min);this.quantity.step=String(mixed?1:step);
      if(!mixed&&Number.isFinite(max))this.quantity.max=String(max);else this.quantity.removeAttribute('max');
      this.offers.forEach(input=>{
        const q=Number(input.value);
        input.disabled=this.mixedAllowed(q)?!this.variants.some(v=>v.available):q<min||q>max||(q-min)%step!==0||!current?.available||(current.tracked&&q>current.stock-cartQuantity);
        input.checked=!input.disabled&&q===Number(this.quantity.value);
      });
    }
    renderUnits(reset=false){
      const area=this.querySelector('[data-units]'),q=Number(this.quantity.value);
      const enabled=this.mixedAllowed(q);
      this.mixed=enabled;
      this.product.querySelectorAll('.shopify-payment-button,shopify-accelerated-checkout').forEach(el=>el.hidden=enabled);
      if(!enabled){area.replaceChildren();return;}
      const previous=reset?[]:[...area.querySelectorAll('[data-unit]')].map(el=>el.value);
      if(!reset&&area.querySelectorAll('[data-unit]').length===q)return;
      area.replaceChildren();
      const heading=document.createElement('p');heading.textContent=this.dataset.variantLabel;area.append(heading);
      for(let i=0;i<q;i++){
        const label=document.createElement('label');label.className='if-offers__unit';
        const text=document.createElement('span');text.textContent='#'+(i+1);
        const select=document.createElement('select');select.dataset.unit='';select.setAttribute('aria-label','Option for item '+(i+1));
        for(const v of this.variants){const option=document.createElement('option');option.value=v.id;option.textContent=v.title+(v.available?'':' — Agotado');option.disabled=!v.available;select.append(option);}
        const candidate=previous[i]||this.currentId;
        const available=this.variants.find(v=>String(v.id)===candidate&&v.available)||this.variants.find(v=>v.available);
        if(available)select.value=String(available.id);
        label.append(text,select);area.append(label);
      }
    }
    selectedOffer(){return this.offers.find(el=>el.checked);}
    offerPercent(offer){
      if(!offer||offer.dataset.discountReady!=='true')return 0;
      const configured=Number(offer.dataset.percent)||0;
      if(configured>0)return Math.max(0,Math.min(90,configured));
      if(Number(offer.dataset.fixed)>0)return 0;
      const benefit=offer.nextElementSibling?.querySelector('[data-benefit],.if-offer__benefit');
      const match=benefit?.textContent.match(/^\s*(\d+(?:[.,]\d+)?)\s*%\s*OFF\s*$/i);
      return Math.max(0,Math.min(90,Number(match?.[1]?.replace(',','.'))||0));
    }
    discount(total,offer){
      if(!offer||offer.dataset.discountReady!=='true')return total;
      const percent=this.offerPercent(offer);
      const fixed=this.dataset.currency===this.dataset.shopCurrency?Math.max(0,Number(offer.dataset.fixed)||0)*100:0;
      return Math.max(0,Math.round(total-(percent?total*percent/100:fixed)));
    }
    money(cents){return new Intl.NumberFormat(document.documentElement.lang||'es',{style:'currency',currency:this.dataset.currency||'USD'}).format(cents/100);}
    renderOfferPrice(total,offer,compareAt=0){
      const element=offer?.nextElementSibling?.querySelector('[data-total]');
      if(!element)return;
      const discounted=this.discount(total,offer);
      const reference=Number(offer.value)===1&&compareAt>total?compareAt:total;
      element.replaceChildren();
      if(discounted<reference){
        const previous=document.createElement('s');
        previous.className='if-offer__compare';
        previous.textContent=this.money(reference);
        element.append(previous);
      }
      const current=document.createElement('span');
      current.className='if-offer__current';
      current.textContent=this.money(discounted);
      element.append(current);
    }
    renderPrices(){
      const v=this.current();
      for(const offer of this.offers){
        const total=(v?.price||0)*Number(offer.value);
        this.renderOfferPrice(total,offer,Number(v?.compare_at_price)||0);
        const benefit=offer.nextElementSibling.querySelector('.if-offer__benefit');
        if(benefit&&offer.dataset.discountReady==='true'&&Number(offer.dataset.percent)>0&&/^\s*\d+\s*%\s*off\s*$/i.test(benefit.textContent))benefit.textContent=Number(offer.dataset.percent)+'% OFF';
      }
      const selected=this.selectedOffer();
      this.querySelector('[data-estimate]').hidden=!selected||(this.offerPercent(selected)<=0&&!(selected.dataset.discountReady==='true'&&Number(selected.dataset.fixed)>0&&this.dataset.currency===this.dataset.shopCurrency));
      const mixedTotal=this.querySelector('[data-mixed-total]');
      mixedTotal.hidden=!this.mixed;
      if(this.mixed){
        const chosen=[...this.querySelectorAll('[data-unit]')].map(select=>this.variants.find(x=>String(x.id)===select.value));
        const total=chosen.reduce((sum,variant)=>sum+(variant?.price||0),0);
        mixedTotal.textContent='Total for selected options: '+this.money(this.discount(total,selected));
        if(selected)this.renderOfferPrice(total,selected,chosen.length===1?Number(chosen[0]?.compare_at_price)||0:0);
      }
    }
    items(){
      const counts=new Map();
      for(const select of this.querySelectorAll('[data-unit]'))counts.set(select.value,(counts.get(select.value)||0)+1);
      return [...counts].map(([id,quantity])=>({id:Number(id),quantity}));
    }
    validateItems(items,cartItems=[]){
      for(const item of items){
        const v=this.variants.find(v=>v.id===item.id);
        const inCart=cartItems.filter(line=>Number(line.variant_id)===item.id).reduce((n,line)=>n+line.quantity,0);
        const combined=item.quantity+inCart;
        if(!v||!v.available)throw new Error('This option is unavailable. Please choose another.');
        if(combined<v.min||(combined-v.min)%v.step!==0||(v.max!==null&&combined>v.max))throw new Error('Check the quantity for '+v.title+': it does not meet the quantity requirements.');
        if(v.tracked&&combined>v.stock)throw new Error('There is not enough stock of '+v.title+' to add this quantity to your cart.');
      }
      if(items.reduce((n,item)=>n+item.quantity,0)!==Number(this.quantity.value))throw new Error('Please check the options selected for your bundle.');
    }
    async submit(event){
      if(!this.mixed)return;
      event.preventDefault();event.stopImmediatePropagation();
      const button=this.form.querySelector('[type=submit]'),error=this.querySelector('[data-offer-error]');
      if(this.busy||!button||button.disabled||button.getAttribute('aria-disabled')==='true')return;
      error.hidden=true;
      let requestSent=false;
      try {
        if(!this.quantity.checkValidity())throw new Error('Please check the selected quantity.');
        const items=this.items();
        const formData=new FormData(this.form),properties={};
        for(const [key,value] of formData){
          const match=/^properties\[(.+)\]$/.exec(key);
          if(match){if(value instanceof File&&value.size)throw new Error('For products with file attachments, use the standard quantity selector.');if(typeof value==='string')properties[match[1]]=value;}
        }
        const sellingPlan=formData.get('selling_plan');
        if(sellingPlan)throw new Error('For subscriptions, use the standard quantity selector.');
        items.forEach(item=>{if(Object.keys(properties).length)item.properties=properties;});
        this.busy=true;button.setAttribute('aria-disabled','true');button.classList.add('loading');
        const spinner=button.querySelector('.loading__spinner');spinner?.classList.remove('hidden');
        const cartResponse=await fetch(`${window.Shopify?.routes?.root||'/'}cart.js`,{headers:{'Accept':'application/json'}});
        if(!cartResponse.ok)throw new Error('We could not verify your cart. Please try again.');
        const existingCart=await cartResponse.json();this.validateItems(items,existingCart.items||[]);
        const cart=document.querySelector('cart-drawer')||document.querySelector('cart-notification');
        const payload={items};
        if(cart){payload.sections=cart.getSectionsToRender().map(s=>s.id);payload.sections_url=location.pathname;cart.setActiveElement(document.activeElement);}
        requestSent=true;
        const response=await fetch(window.routes.cart_add_url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
        const result=await response.json();
        if(!response.ok||result.status){
          const message=typeof result.description==='string'?result.description:'We could not add the entire bundle. Please check availability.';
          await this.refreshCart(cart);
          throw new Error(message+' Check your cart before adding again.');
        }
        if(!cart){location.assign(window.routes.cart_url);return;}
        try {
          if(cart.tagName!=='CART-DRAWER'&&(!result.sections||cart.getSectionsToRender().some(section=>!result.sections[section.id]))){location.assign(window.routes.cart_url);return;}
          publish(PUB_SUB_EVENTS.cartUpdate,{source:'if-quantity-offers',cartData:result});
          await cart.renderContents({...result,key:result.items?.[0]?.key||result.key});
        } catch {
          location.assign(window.routes.cart_url);
        }
      }catch(e){error.replaceChildren();error.append(document.createTextNode(e.message||'We could not connect to the store. Please try again.'));
        if(requestSent){const link=document.createElement('a');link.href=window.routes.cart_url;link.textContent=' View cart';error.append(link);}
        error.hidden=false;
      }
      finally{this.busy=false;button.removeAttribute('aria-disabled');button.classList.remove('loading');button.querySelector('.loading__spinner')?.classList.add('hidden');}
    }
    async refreshCart(cart){
      if(!cart||cart.tagName!=='CART-DRAWER')return;
      try{
        const response=await fetch(`${window.routes.cart_url}?sections=${cart.getSectionsToRender().map(s=>s.id).join(',')}`);
        if(!response.ok)return;
        const sections=await response.json();
        if(cart.getSectionsToRender().some(s=>!sections[s.id]))return;
        await cart.renderContents({sections});
      }catch{}
    }
    disconnectedCallback(){this.abort?.abort();this.unsubscribe?.();this.qtyUnsubscribe?.();this.quantity?.closest('.product-form__quantity')?.classList.remove('if-offers-ready');}
  });
}
